import { render, staticRenderFns } from "./blockDetail.vue?vue&type=template&id=33550217&scoped=true&"
import script from "./blockDetail.vue?vue&type=script&lang=js&"
export * from "./blockDetail.vue?vue&type=script&lang=js&"
import style0 from "./blockDetail.vue?vue&type=style&index=0&id=33550217&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33550217",
  null
  
)

export default component.exports